import {
  podCurrentStatusToDisplayString,
  podCurrentStatusToMachineString,
} from "./podStatus";

/**
 * Workflow tasks from the API may use `status: string` or a nested object with `current_status`.
 * Returns the primary status value for column mapping and display helpers.
 */
export function workflowTaskPrimaryStatus(statusField: unknown): unknown {
  if (statusField == null) return undefined;
  if (typeof statusField === "string") return statusField;
  if (
    typeof statusField === "object" &&
    statusField !== null &&
    "current_status" in statusField
  ) {
    return (statusField as { current_status?: unknown }).current_status;
  }
  return undefined;
}

/** Maps workflow task status (string or `{ label, value }`) to fixed Kanban column ids. */
export function workflowTaskStatusToColumnId(taskStatus: unknown): string {
  const s =
    podCurrentStatusToMachineString(taskStatus) ||
    podCurrentStatusToDisplayString(taskStatus);
  if (!s) return "todo";
  switch (s.toLowerCase()) {
    case "scheduled":
    case "pending":
    case "to do":
      return "todo";
    case "in_progress":
    case "in progress":
    case "development":
      return "inprogress";
    case "blocked [om team member]":
    case "blocked [client]":
    case "blocked":
    case "review":
    case "waiting on client":
    case "on hold":
      return "blocked";
    case "completed":
    case "done":
    case "archived":
      return "done";
    default:
      console.warn(`Unknown task status: ${s}, mapping to 'todo'`);
      return "todo";
  }
}
